import { React, useEffect } from "react";
import { 
  Container, 
  Grid, 
  GridColumn, 
  GridRow, 
  Header, 
  Image, 
} from "semantic-ui-react";
import OurWorkImages from "./ourWorkImages";

export default function LandingPage(props) {

  useEffect(() => {
    document.title = "Splinters Woodwork | Handcrafted Tasmanian Timber & Resin Creations"
  }, []);

  const h1Style = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "4em",
  }

	const h1StyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "3em",
  }

  const h1WhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "4em",
  }

	const h1WhiteStyleMobile = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "3em",
  }

  const pStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#8C8C8C",
		fontSize: "1.1em",
  }

  const pWhiteStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#F9F5F5",
		fontSize: "1.1em",
    lineHeight: "1.4em",
  }

  return (
    <main>
      <Grid>
        <GridRow 
          style={{ 
            position: 'relative',  
            width: '100vw', 
            overflow: 'hidden', 
            margin: '-13em 0em 0em 0em',
          }}
        >
          <GridColumn style={{ padding: '0' }}>
            <Image
              src="./forestHeaderImage.webp"
              title="Splinters Woodwork - Tasmanian Handcrafted Timber and Resin Products"
              alt="Forest with text that says handcrafted Tasmanian timber and resin Ccreations"
              fluid
              style={{ 
                maxHeigh: "100vh" 
              }}
            />
          </GridColumn>
        </GridRow>
      </Grid>


      <Grid>
        <GridRow only="computer tablet" style={{ padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='How we began'
              style={h1Style}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile" style={{ padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='How we began'
              style={h1StyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{ padding: "0em 0em 10em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pStyle}>
              John "Splinter" Whiley has always had a passion for Tasmanian timbers. In 
              2015, he and his wife Judy transformed this interest into Splinters Woodwork, 
              evolving from crafting basic chopping boards to creating high-end furniture 
              and unique resin-enhanced pieces. Their bespoke range includes dining tables, 
              bar tables, coffee tables, and popular items like Tassie Timber bread knives, 
              which have over 2,200 sold. Committed to quality, John and Judy handcrafted 
              each piece, from timber and resin clocks to serving boards and lazy Susans. 
              Explore their creations and discover the beauty of Tasmanian timber. Custom 
              orders are always welcome, ensuring every piece is a unique work of art.
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>

      
      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./topBreak.svg"
              alt="Decorative top break"
            />
          </GridColumn>
        </GridRow>
      </Grid>
      
      <Grid>
        <GridRow only="computer tablet" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='Our Work'
              style={h1WhiteStyle}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile" style={{backgroundColor: "#C2CDBE", padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='Our Work'
              style={h1WhiteStyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{backgroundColor: "#C2CDBE", padding: "0em 0em 2em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pWhiteStyle}>
              Splinter specialises in quality timber and resin pieces ranging from laminated 
              boards, cheese knives, butter knives, bread knives and wine stoppers to timber 
              & resin boards, lazy susans and custom-made statement pieces of furniture. 
              Each piece of Tasmanian timber is carefully selected and inlaid in various 
              colours to create an exceptional work of art.
              <br/><br/>
              Splinter legally sources Tasmanian timber and can produce their work in-house. 
              Whether it is black heart sassafrass, myrtle, tas oak, blackwood or the famous 
              huon pine, Splinters Woodwork has many timbers to choose from for whatever you 
              desire.
            </Container>
          </GridColumn>
        </GridRow>

        <GridRow>
          <GridColumn>
            <OurWorkImages/>
          </GridColumn>
        </GridRow>

        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
      </Grid>


      <Grid>
        <GridRow only="computer tablet" style={{ padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='Mission Statement'
              style={h1Style}
            />
          </GridColumn>
        </GridRow>
        <GridRow only="mobile" style={{ padding: "10em 0em 3em 0em" }}>
          <GridColumn textAlign="center">
            <Header
              as='h2'
              content='Mission Statement'
              style={h1StyleMobile}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{ padding: "0em 0em 10em 0em" }}>
          <GridColumn textAlign="center">
            <Container style={pStyle}>
              At Splinters Woodwork, our mission is to create bespoke, handmade, high-end quality pieces using 
              the finest Tasmanian timbers. Each item is meticulously crafted in-house, ensuring that every 
              piece is unique and made to order. We are dedicated to utilising the timber we have on hand, 
              embracing the natural beauty and character of each wood type. Our commitment to niche, custom-made 
              creations guarantees that our clients receive exclusive, one-of-a-kind works of art that reflect 
              the exceptional craftsmanship and rich heritage of Tasmania.
            </Container>
          </GridColumn>
        </GridRow>
      </Grid>


      <Grid>
        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./topBreak.svg"
              alt="Decorative top break"
            />
          </GridColumn>
        </GridRow>
      </Grid>
      
      <Grid>
        <GridRow 
          only="computer tablet" 
          columns={2}
          style={{
            backgroundColor: "#C2CDBE", 
            padding: "10em 0em 10em 0em" 
          }}
        >
          <GridColumn textAlign="left" verticalAlign="middle" style={{ padding: "0em 2em 0em 2em" }}>
            <Header
              as='h2'
              content='Meet John & Judy'
              style={h1WhiteStyle}
            />
            <Container style={pWhiteStyle}>
              Splinter, aka John Whiley, grew up in remote Tasmania on the edge of its heritage wilderness. A 
              passion for beautiful local timber began in his childhood and became a lifelong hobby. That hobby 
              has now evolved into an art, and John and his wife Judy are enjoying their early retirement years 
              creating magnificent pieces from stunning Tasmania timbers for those who are looking for that 
              talking point for their house.
            </Container>
          </GridColumn>
          <GridColumn style={{ padding: "0em 2em 0em 2em" }}>
            <Image
              src="./john.webp"
              title="John from Splinters Woodwork cutting a slab of timber"
              alt="John from Splinters Woodwork cutting a slab of timber in his workshop"
              circular
              style={{ border: "solid 0.5em #92A082", }}
            />
          </GridColumn>
        </GridRow>
        <GridRow 
          only="mobile" 
          columns={1}
          style={{
            backgroundColor: "#C2CDBE", 
            padding: "10em 0em 10em 0em" 
          }}
        >
          <GridColumn textAlign="center" style={{ padding: "0em 1em 3em 1em" }}>
            <Header
              as='h2'
              content='Meet John & Judy'
              style={h1WhiteStyleMobile}
            />
            <Container style={pWhiteStyle}>
              Splinter, aka John Whiley, grew up in remote Tasmania on the edge of its heritage wilderness. A 
              passion for beautiful local timber began in his childhood and became a lifelong hobby. That hobby 
              has now evolved into an art, and John and his wife Judy are enjoying their early retirement years 
              creating magnificent pieces from stunning Tasmania timbers for those who are looking for that 
              talking point for their house.
            </Container>
          </GridColumn>
          <GridColumn style={{ padding: "0em 2em 0em 2em" }}>
            <Image
              src="./john.webp"
              title="John from Splinters Woodwork cutting a slab of timber"
              alt="John from Splinters Woodwork cutting a slab of timber in his workshop"
              circular
              style={{ border: "solid 0.5em #92A082" }}
            />
          </GridColumn>
        </GridRow>

        <GridRow style={{padding: "0em 0em 0em 0em" }}>
          <GridColumn>
            <Image
              src="./bottomBreak.svg"
              alt="Decorative bottom break"
            />
          </GridColumn>
        </GridRow>
      </Grid>
    </main>
  )
}